import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../../types/product';
import { products as allProducts } from '../../data/products';
import { createSlug } from '../../utils/slug';
import './BestSellers.css';

const BestSellers: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState<string>('all');

  const products: Product[] = allProducts;

  return (
    <section className="best-sellers">
      <div className="container">
        <div className="section-header">
          <p className="section-label">Mới về</p>
          <h2 className="section-title">SẢN PHẨM BÁN CHẠY</h2>
          {/* <div className="filter-tabs">
            <button 
              className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => setActiveFilter('all')}
            >
              All
            </button>
            <button 
              className={`filter-btn ${activeFilter === 'best' ? 'active' : ''}`}
              onClick={() => setActiveFilter('best')}
            >
              Best seller
            </button>
            <button 
              className={`filter-btn ${activeFilter === 'sale' ? 'active' : ''}`}
              onClick={() => setActiveFilter('sale')}
            >
              Sale
            </button>
          </div> */}
        </div>
        <div className="products-grid-large">
          {products.map((product) => (
            <Link key={product.id} to={`/product/${createSlug(product.name)}`} className="product-item-link">
              <div className="product-item">
                {product.isSale && <div className="product-badge sale">Giảm giá</div>}
                <div className="product-image">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    onError={(e) => {
                      console.error('Image load error:', product.image);
                    }}
                  />
                  <div className="product-actions">
                    <a href="#wishlist" className="wishlist-btn" title="View My wishlist" onClick={(e) => e.preventDefault()}>
                      <i className="fas fa-heart"></i>
                    </a>
                    <a href="#wishlist-add" className="wishlist-btn" title="Add to wishlist" onClick={(e) => e.preventDefault()}>
                      <i className="far fa-heart"></i>
                    </a>
                  </div>
                </div>
                <div className="product-details">
                  <h4>{product.name}</h4>
                  <div className="product-price">
                    <span className="current-price">{product.price.toLocaleString('vi-VN')}đ</span>
                    {product.oldPrice && (
                      <span className="old-price">{product.oldPrice.toLocaleString('vi-VN')}đ</span>
                    )}
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BestSellers;

